import {
  Component,
  ElementRef,
  EventEmitter,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core'
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'
import { MessageService } from 'primeng/api'
import { DatePipe } from '@angular/common'
import { BreadcrumbService } from '../../shared-components/breadcrumb.service'
import { NotesTemplate, UiPreferences } from '../../../../api/models'
import { NotesTemplateService } from '../../../../api/services'
import { validateAllFormFields } from '../../../../formUtils'
import { environment } from '../../../../../environments/environment'
import { Observable, Subject } from 'rxjs'
import { FormioComponent } from '@formio/angular'
import {
  debounceTime,
  distinctUntilChanged,
  switchMap,
  takeUntil,
} from 'rxjs/operators'

@Component({
  selector: 'app-notes',
  templateUrl: './notes.component.html',
  styleUrls: ['./notes.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class NotesComponent implements OnInit, OnDestroy {
  Item = 'Add Patient Note'
  noteform: UntypedFormGroup
  providerList: any
  categoriesList: any
  TemplateList: any
  IsTemplateData = false
  currentTemplate: Observable<NotesTemplate>
  template: any
  formio: FormioComponent
  triggerRefresh: EventEmitter<any> = new EventEmitter<any>()
  submission: any
  private formioHtml: FormioComponent

  debouncer: Subject<any> = new Subject<any>()
  private destroyed: Subject<any> = new Subject<any>()
    preferences: UiPreferences = {};
  constructor(
    private fb: UntypedFormBuilder,
    private router: Router,
    private messageService: MessageService,
    private breadcrumbService: BreadcrumbService,
    private notesService: NotesTemplateService,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    private ngZone: NgZone,
  ) {
    this.debouncer
      .asObservable()
      .pipe(debounceTime(300), takeUntil(this.destroyed))
      .subscribe((value) => {
        console.log('refreshing')
        this.triggerRefresh.emit(value)
      })
  }

  ngOnDestroy(): void {
    this.destroyed.next('')
  }

  @ViewChild(FormioComponent)
  set formioComponent(t) {
    if (t) {
      this.formio = t
    }
  }

  @ViewChild('formioHtml')
  set formioTemplateHtml(t: FormioComponent) {
    if (t) {
      this.formioHtml = t
    }
  }

  ngOnInit() {
    this.noteform = this.fb.group({
      noteTitle: new UntypedFormControl('', [Validators.required]),
      noteDate: new UntypedFormControl((new Date()), [Validators.required]),
      providerId: new UntypedFormControl('', [Validators.required]),
      templateId: new UntypedFormControl(0),
      categoryId: new UntypedFormControl('', [Validators.required]),
      description: new UntypedFormControl(''),
      patientId: new UntypedFormControl(''),
        practiceId: new UntypedFormControl('')
    })


      const storedPreferences = localStorage.getItem('uiPreferences');
      if (storedPreferences) {
          this.preferences = JSON.parse(storedPreferences);

          console.table(this.preferences);

          this.Item = this.preferences?.notes || 'Patient Note';

          this.Item = "Add " + this.Item;
      }

     
      this.FillAddNoteForm();
      this.getTransformedDate();


     

     
  }

  FillAddNoteForm() {
    this.notesService
      .notesTemplateAddPatientNotes({
        emrpracticeId: localStorage.getItem('EmrPracticeId'),
      })
      .subscribe((Result) => {
        this.providerList = Result.providers

        this.categoriesList = Result.categories

       // this.noteform.patchValue(Result)
      })
  }

  setTempatedd() {
    this.notesService
      .notesTemplateFindTemplatesByCategory({
        CategoryId: this.noteform.value.categoryId,
      })
      .subscribe((Result) => {
        console.log(Result)
        this.TemplateList = Result
      })
  }

  getNoteTemplateData() {
    if (this.noteform.value.templateId != null) {
      this.IsTemplateData = true

      this.notesService
        .notesTemplateGet({ id: +this.noteform.value.templateId })
        .subscribe((t) => {
          this.template = JSON.parse(t.templateData)
        })
      /// to get template data passing this.noteform.value.templateId.notesTemplateId
    } else {
      this.IsTemplateData = false
    }
  }

    save() {
        debugger;
    validateAllFormFields(this.noteform)
    let formioFormValidity = true


    if( this.noteform.value.templateId>0)
    {
      formioFormValidity=this.formio?.formio?.checkValidity();
    }
    if (this.IsTemplateData === true) {
      this.noteform.patchValue({
        description:
          this.formioHtml.formioElement.nativeElement.querySelector(
            '.formio-form',
          ).innerHTML,
      })
      console.log(
        this.formioHtml.formioElement.nativeElement.querySelector(
          '.formio-form',
        ).innerHTML,
      )
    }
    // console.log(this.noteform.value);
    if (this.noteform.invalid || !formioFormValidity) {
      return
    }

        this.noteform.value.patientId = sessionStorage.getItem('ptId');
        this.noteform.value.practiceId = localStorage.getItem('EmrPracticeId');
        this.noteform.value.patientNoteJSON = JSON.stringify(this.submission);

    // if (this.noteform.value.templateId.templateId != null) {
    //    this.noteform.value.templateId = this.noteform.value.templateId.templateId;
    // }
    // else {
    //    this.noteform.value.templateId = null;
    // }

    this.noteform.value.noteDate = this.datePipe.transform(
      this.noteform.value.noteDate,
      environment.dateformat,
    )
    console.log(this.noteform.value)
    this.notesService
      .notesTemplateCreatePdf({
          body: this.noteform.value,
          patientId: sessionStorage.getItem('ptId')
      })
      .subscribe((Result) => {
        console.log(Result)

        if (Result.status.toLowerCase().indexOf('error') > -1) {
          this.messageService.add({
            key: 'alertToast',
            severity: 'error',
            detail: Result.message,
            summary: 'ERROR',
            life: 5000,
          })
        } else if (Result.status.toLowerCase().indexOf('success') > -1) {
          this.messageService.add({
            key: 'alertToast',
            severity: 'success',
            detail: Result.message,
            summary: 'Confirmation',
            life: 6000,
          })
          this.router.navigate(['Patient', 'dashboard'])
        }
      })
  }

  formioChanged(event) {
    if (event && event.data) {
      const d = {
        submission: {
          data: event.data,
        },
      }
      this.submission = event.data
      this.debouncer.next(d)
    }
  }

  doNothing(event) {
    event.preventDefault()
    }


    getTransformedDate() {
        return this.datePipe.transform(
            this.noteform.value.apptDate,
            environment.dateformat,
        )
    }
}
